import styled from "styled-components";
import { theme } from '../../theme'

export const StyledTopWrapper = styled.div`
    background-color: #E7505A;
`

export const StyledContainer = styled.div`
    margin: 0 auto;
    padding: 4rem 1rem;
    max-width: 730px;
`

export const StyledNextPageDivContainer = styled.div`
    margin: 0 auto;
    padding: 1rem 1rem;
    max-width: 730px;
    display: flex;
    align-items: center;
    gap: 4rem;

    @media(max-width: 376px) {
        flex-direction: column;
        gap: 2rem;
    }

    .score-icon-div {
        display: flex;
        align-items: center;
        font-weight: 700;
        font-size: 1.2rem;

        .check-icon-container {
            width: 2rem;
            height: 2rem;
            margin-right: 5px;
            color: #979797;
            svg {
                width: 100%;
                height: 100%;
            }
        }
    }

    .class-icon-div {
        display: flex;
        align-items: center;
        font-weight: 700;
        font-size: 1.2rem;
        /* margin-left: 4rem; */

        .check-icon-container {
            width: 2rem;
            height: 2rem;
            margin-right: 5px;
            color: #979797;
            svg {
                width: 100%;
                height: 100%;
            }
        }
    }

    .next-page-btn-div {
       margin-left: auto;
    }
`

export const StyledMainContentWrapper = styled.div`
background-color: ${theme.colors.grey03};
height: ${({ fullHeight }) => (fullHeight && '100%')};
`
export const StyledNextPageDiv = styled.div`
background-color: ${theme.colors.mainWhite};

`
export const StyledContent = styled.div`
color: ${theme.colors.mainWhite} !important;
    .top {        
        .subject-title {
            font-weight: 700;
            font-size: 5.1rem;
            
            @media only screen and (max-width: 326px) {
                font-size: 4.1rem;
            }
        }
    }

    .bottom {
        font-size: 1.2rem;
        color: #FFFFFF;
        display: flex;
        justify-content: space-between;
    }

    .download-assignment-btns {
        display: flex;
        align-items: center;
        gap: 1.5rem;

        

        @media(max-width: 500px) {
            flex-direction: column;
        }
    }
`
